<template>
  <span class="alice-status" :class="`alice-status--${tone}`">
    <span class="alice-status__dot" />
    {{ label }}
  </span>
</template>

<script>
const STATUS = {
  draft: { label: "Draft", tone: "draft" },
  in_progress: { label: "In progress", tone: "in_progress" },
  done: { label: "Done", tone: "done" },
};
// Legacy keys still in Firestore — map to the current set.
const ALIASES = { analysis: "in_progress", live: "done" };

export default {
  name: "AliceStatusTag",
  props: {
    status: { type: String, default: "draft" },
  },
  computed: {
    config() {
      const key = ALIASES[this.status] || this.status;
      return STATUS[key] || STATUS.draft;
    },
    label() {
      return this.config.label;
    },
    tone() {
      return this.config.tone;
    },
  },
};
</script>

<style scoped>
.alice-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 0;
  line-height: 1;
}
.alice-status__dot {
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 0;
}
.alice-status--draft {
  color: var(--vp-grijs-160);
  background: var(--vp-grijs-20);
}
.alice-status--in_progress {
  color: var(--vp-geel-160);
  background: var(--vp-geel-20);
}
.alice-status--done {
  color: var(--vp-turquoise-160);
  background: var(--vp-turquoise-20);
}
</style>
